import { useUserRepository } from '@ayocore/platform/identity/client/rpc';
import { createRepositoryFilter } from '@ayocore/platform/client/components/RepositoryTable/createRepositoryFilter';
import type { DealRepository } from '@ayocore/erp/crm/server/repositories/DealRepository';

type UserRepo = ReturnType<typeof useUserRepository>;

/**
 * Фильтр сделок по менеджеру партнёра (multi, подзапрос по crm_partners.manager_id).
 * Список включает и уволенных/деактивированных менеджеров (onlyHuman, без фильтра
 * по is_active) — нужны для отчётов по сделкам партнёров бывших сотрудников. Активные
 * менеджеры идут первыми (orderBy 'is_active' desc), внутри группы — по алфавиту (orderByName).
 * Опция «Без менеджера партнёра» (XOR) фильтрует сделки, у партнёра которых пустой manager_id.
 */
export const FilterByPartnerManager = createRepositoryFilter<DealRepository, UserRepo>({
  name: 'partner_manager',
  mode: 'multi',
  placeholder: 'Менеджер партнера...',
  width: 220,
  maxDisplayedValues: 1,
  source: () => useUserRepository().onlyHuman().orderBy('is_active', 'desc').orderByName('asc'),
  displayField: 'name',
  by: (repo, ids) => repo.filterByPartnerManagers(ids),
  without: {
    label: 'Без менеджера партнёра',
    apply: repo => repo.filterWithoutPartnerManager(),
  },
});
